<template>
  <el-dialog
      title="编辑单元信息"
      :visible.sync="unitNameDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="unitForm" :rules="rules" ref="unitForm" label-width="100px">
      <el-form-item label="单元名称" prop="name">
        <el-input v-model="unitForm.name" placeholder="请输入单元名称"></el-input>
      </el-form-item>

      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('unitForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('unitForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {menUpdate} from "@/api/community";
export default {
  name: "unitNameDialog",
  props: {
    unitNameDialog: {
      type: Boolean,
      default: false
    },
    editId: {
      type: Number,
      default() {
        return 0;
      }
    },
    editName: {
      type: String,
    }
  },
  data() {

    return {
      unitForm: {
        name: '',
      },
      rules: {
        name: [{required: true, message: '请输入单元名称', trigger: 'blur'}],
      }
    }
  },
  computed:{
    user() {
      return this.$store.state.user
    }
  },
  methods:{
    resetForm(formName){
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog',false)
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await menUpdate(
          this.editId,
          this.unitForm.name,
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    unitNameDialog() {
      this.unitForm = {
        name: this.editName,
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>